// extracted by mini-css-extract-plugin
export default {"formInputLighter":"FormInputLighter_formInputLighter__rkBhA","formInputLighter__title":"FormInputLighter_formInputLighter__title__0eIgd","error":"FormInputLighter_error__T0gjR"};